var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ops-chart",style:({ height: `${_vm.height}px` })},[_c('canvas',{ref:"canvas",staticClass:"ops-chart__canvas",attrs:{"role":"img","aria-label":_vm.label}})])
}
var staticRenderFns = []

export { render, staticRenderFns }